export interface QuoteModel {
  description: string;
  fullCost: string;
  monthlyCost: string;
  policyTermMonths: string;
  workOrderNumber?: string;
}
